var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.formatted_address)?_c('p',[_vm._v("\n\t\t"+_vm._s(_vm.formatted_address)+"\n\t")]):_vm._e(),_c('v-responsive',{attrs:{"aspect-ratio":16/9}},[_c('div',{ref:"map",staticStyle:{"width":"100%","height":"100%"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }